export const notices = {
  btn_create_notice: '新規投稿',
  form: {
    input_labels: {
      title: 'タイトル',
      category: 'カテゴリ',
      content: '本文',
      image: '画像（横800px・縦600px）本文の最後に挿入されます',
    },
    input_placeholder: {
      title: 'タイトル',
      category: 'カテゴリを選択してください',
      content: '本文'
    },
  },
  btn_update_notice: '投稿を編集する',
  btn_back_list_notice: '一覧へ戻る',
  btn_delete: '削除する',
  btn_cancle_delete: '削除せず戻る',
  delete: {
    title: '以下の投稿を本当に削除しますか？'
  },
  textType: {
    user: '【お知らせ（ユーザー向け）】',
    partner: '【お知らせ（加盟店向け）】',
  }
}
